import Http from '@/utils/http'

const DRIVER_ENDPOINT = '/account/users/drivers/'

export const postDriver = (data) => Http.post(DRIVER_ENDPOINT, data)
export const getDriver = (id) => {
  return Http.get(`${DRIVER_ENDPOINT + id}/`)
}
export const getDrivers = () => Http.get(DRIVER_ENDPOINT)
export const deleteDriver = (id) => {
  return Http.delete(`${DRIVER_ENDPOINT + id}/`)
}
export const putDriver = (data) => {
  return Http.put(`${DRIVER_ENDPOINT + data.id}/`)
}



// WEBPACK FOOTER //
// ./src/services/driver.js